import React from "react";
import { HStack, Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { Callback } from "types";

interface Props {
  label: string;
  onClose: Callback;
}

const FilterTag: React.FC<Props> = ({ label, onClose }: Props) => {
  return (
    <Tag
      size="lg"
      borderRadius="2xl"
      bg="gray.700"
      color="white"
      boxShadow="lg"
    >
      <HStack padding={4} justifyContent="flex-start" spacing={4}>
        <TagCloseButton onClick={onClose} bg="blue.500" ms={-3} />
        <TagLabel>{label}</TagLabel>
      </HStack>
    </Tag>
  );
};

export default FilterTag;
